import QRCode from 'qrcode';  

export async function generateQRCode(transcriptUrl) {
    try {
       
        const qrCodeBase64 = await QRCode.toDataURL(transcriptUrl);
        return qrCodeBase64; 
    } catch (error) {
        console.error("Error generating QR Code:", error);
    }
}

